// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_i","summaryPar":"aj","ratingCategories":"bj","reviewerInfo":"cj","reviewTypes":"dj","expanded":"ej"};